module.exports = __webpack_public_path__ + "mw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mw.svg
// module id = 714
// module chunks = 0